import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Button, Card, CircularProgress, Typography } from '@material-ui/core';

import API from 'utils/api';
import { useSources } from 'hooks';
import { call } from 'utils';
import { LeagueTeamFilter } from 'routes/Dashboard/SportsApi';

import styles from './ImageLibrary.module.scss';

const ImageLibrary = props => {
  const { leagueId, teams: [teamAId, teamBId] = [] } = props;

  const [imageList, setImageList] = useState();
  const [selected, setSelected] = useState();

  const sources = useSources();
  const filter = useRef({});

  const fetchImages = useCallback(
    params =>
      API.getImageLibraryList(params, sources).then(({ data }) => {
        filter.current.league = params.leagueId;
        filter.current.team = params.teamAId;

        setImageList(data);
      }),
    [sources]
  );

  useEffect(() => {
    fetchImages({ leagueId, teamAId, teamBId });
  }, [fetchImages, leagueId, teamAId, teamBId]);

  const renderImageGrid = () => {
    if (imageList) {
      const images = filter.current.team
        ? imageList.filter(
            ({ metadata }) => metadata && metadata.teamId === filter.current.team
          )
        : imageList;

      return images.length ? (
        <div className={styles.list}>
          {images.map(it => (
            <Card
              key={it._id}
              className={styles.card}
              style={{ backgroundImage: buildUrl(it) }}
              onClick={() => setSelected(it)}
            />
          ))}
        </div>
      ) : (
        <Typography variant="body1">No image to display</Typography>
      );
    }

    return <CircularProgress />;
  };

  const renderPreview = image => {
    return (
      <div className={styles.preview}>
        <div className={styles.image} style={{ backgroundImage: buildUrl(image) }} />

        <div className={styles.controls}>
          <Button onClick={() => setSelected(null)}>Back</Button>

          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setSelected(null);

              call(props.send, {
                imageFile: selected._id,
                imageUrl: buildUrl(selected, false),
                contentType: selected.metadata ? selected.metadata.contentType : null,
              });
            }}
          >
            Send Image
          </Button>
        </div>
      </div>
    );
  };

  const renderFilter = () => {
    if (selected || !imageList) {
      return null;
    }

    return (
      <div className={styles.footer}>
        {leagueId ? null : (
          <LeagueTeamFilter
            onChange={({ leagueId, teamId: teamAId }) =>
              fetchImages({ leagueId, teamAId })
            }
          />
        )}
      </div>
    );
  };

  return (
    <div className={styles.library}>
      <Typography
        variant="subtitle2"
        align="center"
        style={{ padding: 8, userSelect: 'none' }}
      >
        Image Library
      </Typography>

      <div className={styles.content}>
        {selected ? renderPreview(selected) : renderImageGrid()}
      </div>

      {renderFilter()}
    </div>
  );
};

export default ImageLibrary;

const buildUrl = ({ container, blob }, wrap = true) => {
  const url = `https://${container}.s3.amazonaws.com/${blob}`;
  return wrap ? `url(${url})` : url;
};
